import "./StatisticsCart.scss"
import CountUp from "../ countUp/CountUp";

export default function StatisticsCart({title, end, duration}) {
    return (
        <div className={"statisticsCartLayout"}>
            <div className={"statisticsCartContainer"}>
                {title}
            </div>
            <div className={"statisticsCartContent"}>
                <CountUp end={end} duration={duration}/>
            </div>
        </div>
    )
}